export type CrewSyncConfig = { leader: number; members: number[]; resources: number[] };

export function crewSyncConfig(object: Record<string, unknown>): CrewSyncConfig {
  return { leader: Number(object.leader), members: [...((object.members ?? []) as number[])],
    resources: [...((object.resources ?? []) as number[])] };
}

export function crewSyncBlockReason(dirty: boolean, saved: boolean): string | null {
  if (!saved) return "Bitte die Kolonne zuerst laden und speichern.";
  return dirty ? "Bitte zuerst die Änderungen an der Kolonne speichern." : null;
}
